/* eslint-disable no-unused-vars */
import { useTheme } from '@emotion/react';
import {
  Avatar,
  Box,
  Card,
  CardActionArea,
  ClickAwayListener,
  Grid,
  Grow,
  IconButton,
  MenuItem,
  Popper,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import activityicon from 'assets/icons/activitywave.svg';
import { ReactComponent as AddUser } from 'assets/icons/addUser.svg';
import { ReactComponent as BlueTick } from 'assets/icons/blueTick.svg';
import { ReactComponent as Download } from 'assets/icons/download.svg';
import { ReactComponent as Location } from 'assets/icons/location.svg';
import { ReactComponent as Propertymenu } from 'assets/svg/propertymenu.svg';
import settingIcon from 'assets/svg/settingIcon.svg';
import { MarketMetrics } from 'component/MarketMetrics/MarketMetrics';
import { QuickSwitch } from 'component/QuickSwitch/QuickSwitch';
import { useEffect, useState, useRef } from 'react';
import { AgentDashboardLoco } from 'theme/color';
import {
  displayFlex,
  fontsize16,
  poppins400,
  poppins600,
} from 'theme/common.style';
import InvitePopup from '../WelcomeBackScreen/InvitePopup';
import { APP_SCALE } from 'constant/app.config';

const headerData = [
  {
    name: 'Invite People',

    img: <AddUser width={20} height={20} />,
  },
  // {
  //   name: "Generate Report",
  //   img: <Download width={20} height={20} />,
  // },
];

function LocationDetails(props) {
  const {
    North,
    setSwap,
    swap,
    Storeorder,
    profileDetails,
    Inactive,
    isIndividualForMargin,
  } = props;
  const { bluetick } = props;
  const activitystatus = props?.activitystatus;
  const popupRef = useRef(null); // Reference to the popup DOM element
  const properties = props?.profileDetails;
  const watchCount = props?.profileDetails?.PropertyDetails?.watchCount;
  const [isShown, setIsShown] = useState(false);
  const [isPopupHovered, setIsPopupHovered] = useState(false);
  const shouldShowPopup = isShown || isPopupHovered;
  const [isMetric, setIsMetric] = useState(false);
  const [isCLicked, setIsClicked] = useState('white');
  const [lastSeenUser, setLastSeenUser] = useState('');
  const [openInvite, setOpenInvite] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [opensetting, setOpensetting] = useState(false);
  const canBeOpen = opensetting && Boolean(anchorEl);
  const id = canBeOpen ? 'simple-popover' : undefined;
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  const handleMouseMove = (event) => {
    setPopupPosition({
      x: event.clientX + 10, // Offset to prevent overlap with the cursor
      y: event.clientY + 10,
    });
  };

  const [isHovered, setIsHovered] = useState(false);

  const handleClicke = (event) => {
    setAnchorEl(event.currentTarget);
    setOpensetting(!opensetting);
  };
  const handleClosee = () => {
    setAnchorEl(null);
  };
  const useStyles = makeStyles((theme) => ({
    popover: {
      pointerEvents: swap && 'none',
    },
  }));
  const classes = useStyles();

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches = useMediaQuery(theme.breakpoints.down('xl'));
  const matches1800 = useMediaQuery(theme.breakpoints.down(1800));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matches800 = useMediaQuery(theme.breakpoints.down(800));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches600 = useMediaQuery(theme.breakpoints.down(600));
  const matches430 = useMediaQuery(theme.breakpoints.down(430));
  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);
  const dataType = userDetail?.userType;

  // const [selectedRow, setSelectedRow] = useState(null);

  // const handleRowSelect = (rowData) => {
  //   setSelectedRow(rowData);
  // };
  const [menuicon, setMenuicon] = useState(false);
  const [isInsightIcon, setIsInsightIcon] = useState(true);
  const handleMetrics = () => {
    setIsMetric(!isMetric);
    setIsInsightIcon(!isInsightIcon);
  };
  useEffect(() => {
    let lastSeen = localStorage.getItem('lastSeenUser');
    if (lastSeen === 'null') {
      setLastSeenUser('dff');
    } else {
      setLastSeenUser(lastSeen);
    }
  }, []);
  const [activity, setActivity] = useState(false);
  const activityfun = () => {
    // setActivity(!activity);
    // activitystatus(activity);
    const newActivity = !activity;
    setActivity(newActivity);
    activitystatus(newActivity);
  };
  const onDownload = () => {
    const link = document.createElement('a');
    link.download = `download.txt`;
    link.target = '_blank';
    window.open(properties?.PropertyDetails?.reportURL, '_blank');
    // link.href = properties?.PropertyDetails?.reportURL;
    link.click();
  };

  const Invertedmenu = () => {
    return (
      <svg
        width="21"
        height="5"
        viewBox="0 0 21 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.1816 2.49996C12.1816 3.4303 11.4274 4.18449 10.497 4.18449C9.56669 4.18449 8.8125 3.4303 8.8125 2.49996C8.8125 1.56962 9.56669 0.81543 10.497 0.81543C11.4274 0.81543 12.1816 1.56962 12.1816 2.49996Z"
          fill="#666666"
        />
        <path
          d="M3.75968 2.49996C3.75968 3.4303 3.00549 4.18449 2.07515 4.18449C1.14481 4.18449 0.390625 3.4303 0.390625 2.49996C0.390625 1.56962 1.14481 0.81543 2.07515 0.81543C3.00549 0.81543 3.75968 1.56962 3.75968 2.49996Z"
          fill="#666666"
        />
        <path
          d="M20.6034 2.49996C20.6034 3.4303 19.8492 4.18449 18.9189 4.18449C17.9886 4.18449 17.2344 3.4303 17.2344 2.49996C17.2344 1.56962 17.9886 0.81543 18.9189 0.81543C19.8492 0.81543 20.6034 1.56962 20.6034 2.49996Z"
          fill="#666666"
        />
      </svg>
    );
  };
  const WatchIcon = () => {
    return (
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ overflow: 'visible' }}
      >
        <rect
          x="0.742188"
          y="1"
          width="40"
          height="40"
          rx="4.5"
          fill="white"
          fill-opacity="0.25"
          stroke="#C9C9C9"
        />
        <path
          d="M32.9503 21.05C32.7566 20.7682 28.101 14.166 20.7414 14.166C14.4262 14.166 8.79887 20.7302 8.56209 21.0101C8.40118 21.2007 8.40118 21.4806 8.56209 21.6722C8.79887 21.952 14.4262 28.5163 20.7414 28.5163C27.0565 28.5163 32.6838 21.952 32.9206 21.6722C33.0692 21.4959 33.0826 21.2407 32.9503 21.05ZM20.7414 27.4913C15.6788 27.4913 10.8653 22.6634 9.64249 21.3412C10.8633 20.0179 15.6717 15.1911 20.7414 15.1911C26.6649 15.1911 30.846 20.0117 31.8669 21.3135C30.6881 22.5937 25.847 27.4913 20.7414 27.4913Z"
          fill="#BCBCBC"
        />
        <path
          d="M20.7407 17.2422C18.4795 17.2422 16.6406 19.0811 16.6406 21.3422C16.6406 23.6034 18.4795 25.4423 20.7407 25.4423C23.0019 25.4423 24.8407 23.6034 24.8407 21.3422C24.8407 19.0811 23.0019 17.2422 20.7407 17.2422ZM20.7407 24.4173C19.0453 24.4173 17.6656 23.0377 17.6656 21.3423C17.6656 19.6469 19.0453 18.2672 20.7407 18.2672C22.436 18.2672 23.8157 19.6469 23.8157 21.3423C23.8157 23.0377 22.436 24.4173 20.7407 24.4173Z"
          fill="#BCBCBC"
        />
      </svg>
    );
  };

  const InsightColorIcon = () => {
    return (
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.752441"
          y="0.753906"
          width="41"
          height="41"
          rx="5"
          fill="url(#paint0_linear_7389_21280)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26.6377 12.1709C26.6377 10.4844 28.0082 9.11719 29.6988 9.11719C31.3893 9.11719 32.7598 10.4844 32.7598 12.1709C32.7598 13.8575 31.3893 15.2247 29.6988 15.2247C28.0082 15.2247 26.6377 13.8575 26.6377 12.1709ZM31.0416 12.171C31.0416 11.4311 30.4405 10.8314 29.6989 10.8314C28.9573 10.8314 28.3561 11.4311 28.3561 12.171C28.3561 12.9108 28.9573 13.5105 29.6989 13.5105C30.4405 13.5105 31.0416 12.9108 31.0416 12.171ZM25.1088 18.0392C25.3994 17.665 25.939 17.5967 26.3141 17.8866C26.6551 18.1502 26.7427 18.6191 26.5374 18.9833L26.467 19.0891L23.1118 23.4092C22.8463 23.751 22.3735 23.8373 22.008 23.6295L21.9019 23.5583L18.6729 21.0281L15.7739 24.7877C15.5108 25.1287 15.0411 25.2177 14.6754 25.0142L14.5691 24.9443C14.2272 24.6819 14.138 24.2133 14.342 23.8484L14.4121 23.7423L17.8407 19.2967C18.1056 18.9532 18.5797 18.8658 18.946 19.074L19.0524 19.1454L22.2824 21.6772L25.1088 18.0392ZM24.7491 10.938C24.7491 10.4646 24.3645 10.0809 23.89 10.0809H15.5647L15.2964 10.0854C11.5701 10.2103 9.11694 12.9404 9.11694 16.8167V26.0531L9.12105 26.3289C9.2359 30.1614 11.7495 32.7785 15.5647 32.7785H25.4208L25.6892 32.774C29.4168 32.6495 31.8686 29.9276 31.8686 26.0531V18.0092L31.8607 17.8929C31.8038 17.4745 31.4444 17.1521 31.0094 17.1521C30.535 17.1521 30.1503 17.5358 30.1503 18.0092V26.0531L30.1456 26.3192C30.0417 29.2139 28.2352 31.0643 25.4208 31.0643H15.5647L15.3095 31.0593C12.5345 30.9488 10.8352 29.0273 10.8352 26.0531V16.8167L10.8399 16.5504C10.9439 13.6527 12.7528 11.7951 15.5647 11.7951H23.89L24.0065 11.7873C24.4259 11.7305 24.7491 11.3719 24.7491 10.938Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear_7389_21280"
            x1="0.752441"
            y1="0.753906"
            x2="41.7524"
            y2="41.7539"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#6C2AD2" />
            <stop offset="1" stop-color="#75B8F8" />
          </linearGradient>
        </defs>
      </svg>
    );
  };
  const InsightIcon = () => {
    return (
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          opacity="0.1"
          x="1.25256"
          y="1.25391"
          width="40"
          height="40"
          rx="4.5"
          stroke="#112347"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M26.6376 12.1709C26.6376 10.4844 28.0081 9.11719 29.6987 9.11719C31.3892 9.11719 32.7597 10.4844 32.7597 12.1709C32.7597 13.8575 31.3892 15.2247 29.6987 15.2247C28.0081 15.2247 26.6376 13.8575 26.6376 12.1709ZM31.0415 12.171C31.0415 11.4311 30.4403 10.8314 29.6987 10.8314C28.9571 10.8314 28.3559 11.4311 28.3559 12.171C28.3559 12.9108 28.9571 13.5105 29.6987 13.5105C30.4403 13.5105 31.0415 12.9108 31.0415 12.171ZM25.1086 18.0392C25.3992 17.665 25.9388 17.5967 26.3139 17.8866C26.6549 18.1502 26.7425 18.6191 26.5372 18.9833L26.4668 19.0891L23.1116 23.4092C22.8461 23.751 22.3733 23.8373 22.0078 23.6295L21.9017 23.5583L18.6727 21.0281L15.7737 24.7877C15.5106 25.1287 15.0409 25.2177 14.6752 25.0142L14.5689 24.9443C14.227 24.6819 14.1378 24.2133 14.3418 23.8484L14.4119 23.7423L17.8405 19.2967C18.1054 18.9532 18.5795 18.8658 18.9458 19.074L19.0522 19.1454L22.2822 21.6772L25.1086 18.0392ZM24.749 10.938C24.749 10.4646 24.3644 10.0809 23.8899 10.0809H15.5646L15.2963 10.0854C11.5701 10.2103 9.11686 12.9404 9.11686 16.8167V26.0531L9.12097 26.3289C9.23582 30.1614 11.7494 32.7785 15.5646 32.7785H25.4207L25.6891 32.774C29.4167 32.6495 31.8685 29.9276 31.8685 26.0531V18.0092L31.8606 17.8929C31.8038 17.4745 31.4443 17.1521 31.0094 17.1521C30.5349 17.1521 30.1502 17.5358 30.1502 18.0092V26.0531L30.1455 26.3192C30.0417 29.2139 28.2351 31.0643 25.4207 31.0643H15.5646L15.3094 31.0593C12.5345 30.9488 10.8351 29.0273 10.8351 26.0531V16.8167L10.8399 16.5504C10.9438 13.6527 12.7527 11.7951 15.5646 11.7951H23.8899L24.0065 11.7873C24.4258 11.7305 24.749 11.3719 24.749 10.938Z"
          fill="#112347"
        />
      </svg>
    );
  };
  const Locationdown = () => {
    return (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.5055 23.7282C15.4228 23.6476 15.0689 23.3432 14.7779 23.0596C12.9473 21.3973 9.95112 17.0607 9.03656 14.7909C8.8896 14.4462 8.57857 13.5747 8.55859 13.1091C8.55859 12.6629 8.66132 12.2376 8.86963 11.8317C9.16069 11.3258 9.61868 10.92 10.1594 10.6976C10.5347 10.5544 11.6575 10.332 11.6775 10.332C12.906 10.1096 14.902 9.9873 17.1078 9.9873C19.2094 9.9873 21.1241 10.1096 22.3711 10.2917C22.3911 10.3125 23.7865 10.5349 24.2645 10.7782C25.1376 11.2243 25.6798 12.0958 25.6798 13.0285V13.1091C25.6584 13.7165 25.1162 14.9938 25.0963 14.9938C24.1803 17.1413 21.331 21.3778 19.4377 23.0805C19.4377 23.0805 18.9512 23.56 18.6473 23.7685C18.2107 24.0938 17.6699 24.255 17.1292 24.255C16.5257 24.255 15.9635 24.0729 15.5055 23.7282Z"
          fill="#112347"
        />
      </svg>
    );
  };
  const LocationUp = () => {
    return (
      <svg
        width="35"
        height="35"
        viewBox="0 0 35 35"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.7367 10.514C18.8194 10.5946 19.1733 10.899 19.4643 11.1825C21.2949 12.8449 24.2911 17.1815 25.2056 19.4513C25.3526 19.796 25.6636 20.6675 25.6836 21.1331C25.6836 21.5793 25.5809 22.0046 25.3726 22.4104C25.0815 22.9164 24.6235 23.3222 24.0828 23.5446C23.7075 23.6878 22.5847 23.9102 22.5647 23.9102C21.3362 24.1326 19.3402 24.2549 17.1344 24.2549C15.0328 24.2549 13.118 24.1326 11.8711 23.9505C11.8511 23.9296 10.4557 23.7072 9.97773 23.464C9.10455 23.0178 8.56238 22.1464 8.56238 21.2137V21.1331C8.58378 20.5257 9.12595 19.2483 9.14593 19.2483C10.0619 17.1009 12.9112 12.8644 14.8045 11.1617C14.8045 11.1617 15.291 10.6822 15.5949 10.4737C16.0315 10.1484 16.5723 9.9872 17.113 9.9872C17.7165 9.9872 18.2787 10.1693 18.7367 10.514Z"
          fill="#112347"
        />
      </svg>
    );
  };

  return (
    <>
      <Grid
        container
        style={{
          width: '100%',
          flexWrap: 'nowrap', // 🚫 prevent wrapping
          gap: matchessm ? '50px' : '100px',
          display: 'flex',
          justifyContent: menuicon ? 'right' : 'space-between',
          alignItems: 'center',
          flexDirection: 'row',
          marginBottom: isIndividualForMargin && matchessm ? '5px' : '30px',
        }}
      >
        {!menuicon && (
          <Grid
            item
            sx={{
              display: 'flex',
              alignItems: 'center',
              minWidth: 0, // 🔥 important for ellipsis
              flex: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                minWidth: 0,
                maxWidth: '100%',
                gap: '6px',
              }}
            >
              {!matches600 && (
                <Typography sx={displayFlex}>
                  <Location
                    sx={AgentDashboardLoco}
                    width={28.25}
                    height={34.29}
                  />
                  &nbsp;
                </Typography>
              )}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  flexGrow: 1,
                  minWidth: 0,
                  gap: '6px',
                }}
              >
                <Tooltip
                  title={
                    <>
                      {properties?.PropertyDetails?.propertyAddress?.streetName}
                    </>
                  }
                  placement="bottom"
                  disableInteractive
                  componentsProps={{
                    tooltip: {
                      sx: {
                        bgcolor: '#fafafa',
                        boxShadow: '0px 2px 20px lightgray',
                        color: 'black',
                        padding: '10px',
                        fontFamily: 'poppins !important',
                        fontSize: '14px',
                        maxWidth: '800px',
                        marginLeft: '120px',
                      },
                    },
                  }}
                >
                  <Typography
                    sx={{
                      ...poppins600,
                      fontSize: matches430 ? '18px' : '24px',
                      color: '#1E1E1E',

                      flexGrow: 1,
                      flexShrink: 1,
                      flexBasis: 0,

                      minWidth: 0,
                      maxWidth: '100%',

                      overflow: 'hidden',
                      whiteSpace: 'nowrap',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {properties?.PropertyDetails?.propertyAddress?.streetName}
                  </Typography>
                </Tooltip>

                {North && (
                  <BlueTick
                    width={16}
                    height={16}
                    style={{
                      //  marginBottom: '50px',
                      flexShrink: 0,
                    }}
                  />
                )}
                <div>
                  <IconButton
                    onClick={() => setIsShown(!isShown)} // Toggle popup on click
                    onMouseEnter={(e) => {
                      setIsShown(true);
                      handleMouseMove(e); // Update position when hover starts
                    }}
                    // onMouseMove={handleMouseMove} // Dynamically update position
                    // onMouseLeave={() => {
                    //   if (!isHovered) setIsShown(false); // Close popup if not hovering
                    // }}
                  >
                    {!isShown ? (
                      <Locationdown width={34} height={34} />
                    ) : (
                      <LocationUp width={34} height={34} />
                    )}
                  </IconButton>

                  {isShown && (
                    <div
                      ref={popupRef} // Use ref to control the popup's position
                      style={{
                        position: 'fixed', // Follow the cursor position
                        top: '0px', // Initial value (updated dynamically)
                        left: '0px', // Initial value (updated dynamically)
                      }}
                      onMouseEnter={() => setIsHovered(true)} // Keep the popup open when hovered
                      onMouseLeave={() => {
                        setIsHovered(false);
                        setIsShown(false); // Close popup when leaving
                      }}
                    ></div>
                  )}
                </div>
                {!North ? (
                  <Typography
                    // paddingTop={1}
                    sx={displayFlex}
                    onClick={handleMetrics}
                    style={{ cursor: 'pointer' }}
                    marginLeft="10px"
                  >
                    {isInsightIcon ? <InsightIcon /> : <InsightColorIcon />}
                  </Typography>
                ) : null}
              </Box>

              {/* {bluetick &&
          <Typography
            sx={{ ...poppins600, fontSize: "32px", color: "#1E1E1E" }}
          >
           Owen Street,North Bondi 
           
          </Typography>
          
         } */}
            </Box>
          </Grid>
        )}

        {matchesmd && !menuicon ? (
          <Grid
            item
            sx={{
              flexShrink: 0, // 🔥 prevents collapsing
            }}
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Typography
              sx={{
                border: '1px solid #F0F0F0',
                borderRadius: '50%',
                padding: '7px 5px',
                height: '41px',
                display: 'flex',
                alignItems: 'center',
                width: '41px',
                justifyContent: 'center',
              }}
            >
              <Propertymenu
                onClick={() => {
                  setMenuicon(!menuicon);
                }}
              />
            </Typography>
          </Grid>
        ) : (
          <Grid
            item
            sx={{
              flexShrink: 0, // 🔥 prevents collapsing
            }}
            style={{
              display: 'flex',
              justifyContent: 'end',
            }}
          >
            {matches1800 ? null : (
              <Grow in timeout={500} style={{ transformOrigin: 'left center' }}>
                <Stack
                  direction="row"
                  alignItems="center"
                  gap={1}
                  sx={{ overflow: 'visible' }}
                >
                  <Stack direction="row" alignItems="center" gap={0.5}>
                    <WatchIcon sx={{ fontSize: 18, flexShrink: 0 }} />
                    <Typography sx={{ ...poppins400, color: '#666666' }}>
                      {watchCount}
                    </Typography>
                  </Stack>

                  <Typography sx={{ ...poppins400, color: '#666666' }}>
                    watching
                  </Typography>
                </Stack>
              </Grow>
            )}
            {matches1800 && (
              <Grid>
                {!isMetric && (
                  <Grid
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      gap: '5px',
                    }}
                  >
                    <Grid>
                      <Typography>
                        <WatchIcon />
                      </Typography>
                    </Grid>
                    <Grid>
                      <Typography
                        sx={{
                          color: 'rgba(17, 35, 71, 0.5)',
                          fontFamily: 'poppins',
                        }}
                      >
                        {watchCount}
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            )}

            {matches1800
              ? null
              : userDetail?.primaryUserType !== 'Vendor' && (
                  <Grid item sx={{ marginRight: '3px' }}>
                    <Card
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: '8px',
                        // marginRight: "8px",
                        padding: !matches430 ? '8px 16px 8px 16px' : '8px 0px',
                        backgroundColor: 'transparent',
                        cursor: 'default',
                        borderRadius: '5px',
                        border: '1px solid rgba(17, 35, 71, 0.1)',
                        boxShadow: 'none',
                      }}
                    >
                      <Typography>
                        {userDetail?.profileImage == '' ||
                        userDetail?.profileImage == null ? (
                          <Avatar
                            style={{
                              height: '26px',
                              width: '26px',
                              fontFamily: 'poppins',
                              fontSize: '12px',
                              backgroundColor: '#666666',
                            }}
                          >
                            {userDetail?.userName?.charAt(0)?.toUpperCase() +
                              userDetail?.userSurName?.charAt(0)?.toUpperCase()}
                          </Avatar>
                        ) : (
                          <Avatar
                            alt="Remy Sharp"
                            src={userDetail?.profileImage}
                            style={{ height: '26px', width: '26px' }}
                          />
                        )}
                      </Typography>
                      &nbsp;&nbsp;
                      <Typography sx={{ ...poppins400, color: '#666666' }}>
                        Last Seen By
                      </Typography>
                    </Card>
                  </Grid>
                )}
            {headerData.map((data) => (
              <Grid item sx={{ marginRight: '10px' }}>
                <CardActionArea
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: '8px',
                    marginRight: '8px',
                    padding: matchessm ? '9px 2px' : '9px 16px 9px 16px',
                    borderRadius: '5px',
                    // backgroundColor: "#FAFAFA",
                    background: openInvite
                      ? 'linear-gradient(#6C2AD2 0%, #75B8F8 100%)'
                      : 'transparent',
                    border: '1px solid rgba(17, 35, 71, 0.1)',
                    boxShadow: 'none',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    if (data.name == 'Generate Report') {
                      onDownload();
                    }
                    if (data.name == 'Invite People') {
                      setOpenInvite(!openInvite);
                    }
                  }}
                >
                  <Typography>
                    <Avatar
                      style={{
                        background: '#E7E6E6',
                        height: '24px',
                        width: '24px',
                        padding: '4px  ',
                      }}
                    >
                      {data.img}
                    </Avatar>
                  </Typography>
                  {!matches1800 && (
                    <Typography
                      sx={{ ...poppins400, ...fontsize16, color: '#666666' }}
                      // onClick={()=>setValue(1)}
                      onClick={() => {
                        if (data.name == 'Invite People') {
                          setOpenInvite(!openInvite);
                        }
                      }}
                    >
                      &nbsp; {data.name}
                    </Typography>
                  )}
                </CardActionArea>
                <InvitePopup
                  openInvite={openInvite}
                  setOpenInvite={setOpenInvite}
                />
              </Grid>
            ))}

            {userDetail?.primaryUserType == 'Agent' && (
              <Grid item sx={{ marginRight: '10px' }}>
                <CardActionArea
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: '8px',
                    marginRight: '8px',
                    padding: matchessm ? '9px 2px' : '9px 16px 9px 16px',
                    borderRadius: '5px',
                    // backgroundColor: "#FAFAFA",
                    backgroundColor: 'transparent',
                    border: '1px solid rgba(17, 35, 71, 0.1)',
                    boxShadow: 'none',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    onDownload();
                  }}
                >
                  <Typography>
                    <Avatar
                      style={{
                        background: '#E7E6E6',
                        height: '24px',
                        width: '24px',
                        padding: '4px  ',
                      }}
                    >
                      <Download width={24} height={24} />
                    </Avatar>
                  </Typography>
                  {!matches1800 && (
                    <Typography
                      sx={{ ...poppins400, ...fontsize16, color: '#666666' }}
                    >
                      &nbsp; Generate Report
                    </Typography>
                  )}
                </CardActionArea>
                <InvitePopup
                  openInvite={openInvite}
                  setOpenInvite={setOpenInvite}
                />
              </Grid>
            )}

            {matches && !Inactive && (
              <Grid
                item
                onClick={activityfun}
                sx={{ marginLeft: '-3px', cursor: 'pointer' }}
              >
                <Card
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: '8px',
                    marginRight: '8px',
                    padding: matchessm ? '1px 2px' : '1px 8px 1px 8px',
                    backgroundColor: 'transparent',

                    borderRadius: '5px',
                    border: '1px solid rgba(17, 35, 71, 0.1)',
                    boxShadow: 'none',
                    // backgroundColor: lightgray,
                  }}
                >
                  <Typography>
                    <Avatar
                      alt="activity"
                      src={activityicon}
                      height={'24px'}
                      width={'24px'}
                      style={{ padding: '8px' }}
                    />
                  </Typography>
                </Card>
              </Grid>
            )}

            {userDetail?.primaryUserType == 'Agent' && (
              <IconButton onClick={handleClicke}>
                <img alt="cogwheel" src={settingIcon} width={20} />
              </IconButton>
            )}

            <Popper
              id={id}
              open={opensetting}
              anchorEl={anchorEl}
              disablePortal
              sx={{
                boxShadow: 'none',
                border: '1px solid #D9D9D9',
                backgroundColor: 'white',
                borderRadius: '5px',
                display:
                  userDetail?.primaryUserType == 'Agent' ? 'block' : 'none',
                zIndex: 900,
              }}
              placement="bottom-start"
            >
              <ClickAwayListener
                onClickAway={() => {
                  if (swap) {
                    setSwap(false);
                  }

                  setOpensetting(false);
                }}
              >
                <Box>
                  <style>
                    {`
  @keyframes blink {
    0% {
      background: #ffffff;
      color: #2F3F5E;
      transform: scale(1);
      opacity: 0.9;
    }

    50% {
      background: linear-gradient(
        162.58deg,
        #6c2ad2 1.87%,
        #77cffe 98.78%
      );
      color: #ffffff;
      transform: scale(1.02);
      opacity: 1;
    }

    100% {
      background: #ffffff;
      color: #2F3F5E;
      transform: scale(1);
      opacity: 0.9;
    }
  }
`}
                  </style>

                  <MenuItem
                    value={'actionValue'}
                    onClick={() => {
                      if (swap) {
                        Storeorder();
                      }
                      setSwap(!swap);
                    }}
                    style={{
                      animation: swap
                        ? 'blink 2.5s ease-in-out infinite'
                        : 'none',
                      transition: 'all 0.3s ease-in-out',
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: 'Poppins!important',
                        fontWeight: 400,
                        fontSize: `calc(16px * ${APP_SCALE})`,
                        lineHeight: `calc(20px * ${APP_SCALE})`,
                        fontStyle: 'normal',
                      }}
                    >
                      {swap ? 'Set this order' : 'Organize'}
                    </Typography>
                  </MenuItem>
                </Box>
              </ClickAwayListener>
            </Popper>

            {menuicon && (
              <Grid item>
                <Typography
                  sx={{
                    border: '1px solid #F0F0F0',
                    borderRadius: '50%',
                    padding: '7px 5px',
                    height: '41px',
                    // marginTop: "10px",
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: '10px',
                    width: '41px',
                    justifyContent: 'center',
                  }}
                >
                  <IconButton
                    onClick={() => {
                      setMenuicon(!menuicon);
                    }}
                  >
                    <Invertedmenu />
                  </IconButton>
                </Typography>
              </Grid>
            )}

            {/* {matches && (
        <Grid item>
          <Typography
           style={{
              textAlign: "right",
              position: "relative",
              top: "9px",
              paddingLeft: "10px",

            }}
          >
            <img
              alt="cogwheel"
              src={settingIcon}
              width={20}
            />
          </Typography>
        </Grid>
         )} */}
          </Grid>
        )}
      </Grid>
      {isShown && (
        <Box
          sx={{ zIndex: 999, position: 'absolute', top: 205 }}
          onMouseLeave={() => setIsShown(false)}
        >
          <QuickSwitch
            onMouseEnter={() => setIsHovered(true)}
            isShown={isShown}
            setIsShown={setIsShown}
            buyerregister={false}
            vendor={North}
          />
        </Box>
      )}
      {isMetric && (
        <Box sx={{ width: '100%' }}>
          <MarketMetrics />
        </Box>
      )}
    </>
  );
}

LocationDetails.propTypes = {};

export default LocationDetails;
